<style scoped lang="less">
    .container {
        width: 100%;
        /* height: 100%; */
        display:flex;
        justify-content: center;
    }

    .body {
        width: 100%;
        height: 100%;
        
        font-size: 16px;
        display:flex;
        flex-direction:column;
        justify-content: flex-start;
    }
    .el-table {
        width:100%;
        border-bottom: 1px solid black;
        border-right: 1px solid black;
        margin: 0 auto;
    }
    ::v-deep.el-table th {
        border: 1px solid black !important;
         border-right: none !important;
         border-bottom: none !important;
    }

    ::v-deep.el-table td {
        border: 1px solid black;
        border-right: none !important;
    } 

  
   .class1{
        display: flex;
        align-items: center;
        margin: 8px 5px 12px;
   }

   .contactLine{
       min-height: 30px;
       align-items: center;
   }

   .contactLine p{
       height: auto;
       line-height: 30px;
   }

   .contactLine a{
       line-height: 30px;
   }

   .class2{
    width:100%;
   }

   .class3{
    width:100%;
    color: red;
   }

   p{ 
    font-size:14px;
    /* background-color: #cc6e6e; */
    height:30px;
    margin:0;
   }

   input{ 
    width:160px;
    height:30px;
    /* background-color: #cc6e6e; */
   }
   .inputV{
    width:110px;
    height:30px;
    /* background-color: #cc6e6e; */
   }
    .nameInput{
     width:210px;
    }
    .certInput{
     width:210px;
    }
   button{
    width:100px;
    height: 36px;
    background: #0B253B;
    color:white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    box-shadow: 0 2px 6px rgba(17, 47, 216, 0.2);
   }

   button:hover {
        opacity: 0.95;
   }

   .captchaBox {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px 12px;
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        background: #fafafa;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
   }

   .captchaCode {
        display: inline-block;
        min-width: 90px;
        padding: 0 10px;
        border: 1px solid #d0d7de;
        background: linear-gradient(135deg, #fff8c6, #f7f1bb);
        font-weight: bold;
        letter-spacing: 2px;
        text-align: center;
        line-height: 32px;
        border-radius: 4px;
        cursor: pointer;
        user-select: none;
   }

   .captchaCode:hover {
        border-color: #112fd8;
        box-shadow: 0 0 0 2px rgba(17, 47, 216, 0.12);
   }

   .searchImage {
       display: block;
       max-width: 100vw;
       
       width: auto;
       height: auto;
       object-fit: contain;
       margin: 0 auto;
   }

</style>


<template>
    <div class="container">
        <div class="body">
                
                <!-- Part One:搜索 -->

                <p>请输入中文姓名或拼音，并填写证书号进行查询<br>Please enter your Chinese or English name and certificate number</p>
                <br>

                <div class="class1">
                    <p>Name/Pinyin‌<br>姓名/拼音</p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <input v-model="formInline.searchName" class="nameInput" placeholder="eg:李三一 / Li Sanyi">
                </div>

                <div class="class1">
                    <p>Certificate number<br>证书号</p>&nbsp;
                    <input v-model="formInline.searchItem1" class="certInput" placeholder="eg:COE-ICS-2026XXX">
                </div>

                <div class="class1">
                    <p>Verification code<br>验证码</p>&nbsp;
                   
                        <span class="captchaCode" @click="generateCaptcha" title="Click to refresh captcha / 点击刷新验证码">{{ verificationCode }}</span>
                        <input v-model="verificationInput" class="inputV" placeholder="Enter code">
                   
                </div>

                <!--触发按钮-->
                <div class="class1">
                    <button type="primary" @click="searchByNameAndCertNo">Search/搜索</button>&nbsp;&nbsp;&nbsp;
                    <button type="primary" @click="resetVerification">Reset/重置</button>
                    <p v-show="flag2" class="class3">{{ verificationMessage }}</p>
                </div>
                
                <div class="class1 contactLine">
                <p>If you have any other inquiries, please</p>&nbsp;<a href="https://www.tuvsud.cn/zh-cn/contact-us" target="_blank">contact us</a><p>.</p>
                </div>
                <div class="class1 contactLine">
                <p>如果您还有其他疑问，请</p>&nbsp;<a href="https://www.tuvsud.cn/zh-cn/contact-us" target="_blank">联系我们</a><p>。</p>
                </div>
                <br>
            
               

                <div class="class2" v-show="flag1">
                <!-- <div class="class2" v-show="true"> -->
                <!-- Part Two:搜索结果显示 -->

                <!--搜索结果显示表格-->
                <!-- <el-table :data="tableData" border style="width: 50%" header-cell-style="background-color: #6fa0db; color: white" > -->
                    <el-table :data="tableData" border style="width: 100%">

                    <el-table-column prop="certId" label="id" style="width: 50%" v-if="false"></el-table-column>
                    
                    
                  
                    <el-table-column prop="name" label="姓名" style="width: 50%"></el-table-column>
                    <el-table-column prop="pinyin" label="拼音" style="width: 50%"></el-table-column>
                   
                    <el-table-column prop="certNo" label="证书号" style="width: 50%"></el-table-column>

                </el-table>

                <div class="imageSection" v-if="imageUrl || imageError">
                    <div v-if="imageUrl">
                        <img :src="imageUrl" alt="Search result image" class="searchImage" />
                    </div>
                    <div v-else class="class3">图片加载失败</div>
                </div>

                </div>


                <!--没找到提示-->
                <div class="class3" style="min-width: 100%; min-height: 10vh" v-show="flag4">
                    <p class="class3">未找到相关证书</p>
                </div>


        </div>
    </div>
</template>


<script>
    export default {

        data() {
            return {

                /* Part One:搜索*/
                /* 筛选条件表单 */
                formInline: {
                    searchName: "",
                    searchItem1: "",
                },
                verificationCode: "",
                verificationInput: "",
                verificationMessage: "",
                imageUrl: "",
                imageError: false,
                currentImageObjectUrl: "",
                

                /* Part Two:搜索结果显示 */
                id: '',
                tableData: [],

                /* 填写规则限制 */
                NewOneRules: {
                    reportNo: [
                        {
                            required: true,
                            message: "Must input",
                            trigger: "blur",
                        },
                    ],
                    selectMode: [
                        {
                            required: true,
                            message: "Must select",
                            trigger: "blur",
                        },
                    ],
                },

                /*切换位置*/
                flag1:false,
                flag2:false,
                flag4:false,
                
            }
        },

        mounted() {
            this.generateCaptcha();
        },

        methods: {

            generateCaptcha() {
                const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
                let code = "";

                for (let i = 0; i < 4; i += 1) {
                    code += chars.charAt(Math.floor(Math.random() * chars.length));
                }

                this.verificationCode = code;
                this.verificationInput = "";
            },

            showVerificationError(message) {
                this.flag1 = false;
                this.flag2 = true;
                this.flag4 = false;
                this.verificationMessage = message;
                this.verificationInput = "";
                this.generateCaptcha();
            },

            searchByNameAndCertNo() {
                console.log("开始组合查询");
                const name = (this.formInline.searchName || "").trim();
                const certNo = (this.formInline.searchItem1 || "").trim();
                const expectedCode = (this.verificationCode || "").toUpperCase();
                const inputCode = (this.verificationInput || "").trim().toUpperCase();

                if (!inputCode) {
                    this.showVerificationError("请输入验证码");
                    return;
                }

                if (inputCode !== expectedCode) {
                    this.showVerificationError("验证码错误，请重新输入");
                    return;
                }

                this.flag2 = false;
                this.verificationMessage = "";

                if (!name && !certNo) {
                    this.clearImageData();
                    this.showEmptyResult();
                    return;
                }

                this.queryByNameAndCertNo(name, certNo);
                this.fetchCertImage(certNo);
            },
            queryByNameAndCertNo(name = "", certNo = "") {
                this.$axios
                    .get("/api/Cert/query", {
                        params: {
                            QueryName: name,
                            QueryCert: certNo
                        }
                    })
                    .then((res) => {
                        this.handleSearchResult(res);
                    })
                    .catch((err) => {
                        console.log("查询失败", err);
                        this.showEmptyResult();
                    });
            },

            fetchCertImage(certNo = "") {
                this.clearImageData();
                if (!certNo) {
                    return;
                }

                const encodedCert = encodeURIComponent(certNo);
                this.$axios
                    .get(`/api/Cert/image/${encodedCert}`, {
                        responseType: "blob",
                    })
                    .then((res) => {
                        this.handleImageBlobResponse(res.data);
                    })
                    .catch((err) => {
                        console.log("图片请求失败", err);
                        this.imageError = true;
                    });
            },

            handleImageBlobResponse(blob) {
                if (blob && blob.type && blob.type.startsWith("image/")) {
                    this.revokeImageUrl();
                    this.imageUrl = URL.createObjectURL(blob);
                    this.currentImageObjectUrl = this.imageUrl;
                    this.imageError = false;
                    return;
                }

                const reader = new FileReader();
                reader.onload = () => {
                    const text = reader.result || "";
                    if (typeof text === "string" && text.includes("Image not found")) {
                        this.imageError = true;
                    } else {
                        this.imageError = true;
                    }
                };
                reader.onerror = () => {
                    this.imageError = true;
                };
                reader.readAsText(blob);
            },

            revokeImageUrl() {
                if (this.currentImageObjectUrl) {
                    URL.revokeObjectURL(this.currentImageObjectUrl);
                    this.currentImageObjectUrl = "";
                }
            },

            clearImageData() {
                this.revokeImageUrl();
                this.imageUrl = "";
                this.imageError = false;
            },

            handleSearchResult(res) {
                console.log("查询成功")
                console.log(res.data)
                if (res.status == 200) {
                    const payload = res.data || {};
                    const list = Array.isArray(payload.data)
                        ? payload.data
                        : Array.isArray(payload)
                            ? payload
                            : [];

                    this.tableData = list;
                    if (list.length === 0) {
                        this.showEmptyResult();
                    } else {
                        this.flag1 = true;
                        this.flag2 = false;
                        this.flag4 = false;
                    }
                }
            },
          
            showEmptyResult() {
                this.tableData = [];
                this.flag1 = false;
                this.flag2 = false;
                this.flag4 = true;
                this.verificationMessage = "";
            },
            resetVerification() {
                this.formInline.searchName = "";
                this.formInline.searchItem1 = "";
                this.verificationInput = "";
                this.verificationMessage = "";
                this.flag1 = false;
                this.flag2 = false;
                this.flag4 = false;
                this.clearImageData();
                this.generateCaptcha();
            },

            /* 搜索 */
        },
    };
</script>



